/**
 * Testi italiani dell'account Google di institor (ADR 0012): connessione di
 * piattaforma, progetto Google gestito di un progetto institor, migrazione
 * verso un account dell'utente, consumi.
 *
 * «Proprietario», «IAM» e «Fatturazione» sono le voci della console Google
 * Cloud in italiano: restano così perché è lì che l'utente le cerca.
 */

/** Testi dell'account Google di institor. */
export const googleManaged = {
  /** Sezione della pagina Strumenti, solo per chi amministra la piattaforma. */
  platform: {
    /** Titolo. */
    title: 'Account Google di institor',
    /** Che cosa fa. */
    intro:
      'I progetti che non collegano un account Google loro usano questo, senza vederne le credenziali. Per ogni progetto institor prepara un progetto Google Cloud separato.',
    /** Pulsante di collegamento e titolo del cassetto. */
    connect: 'Collega l’account di institor',
    /** Nessuna connessione. */
    empty: 'Nessun account collegato. I progetti senza un account Google loro non hanno Google.',
    /** Lettura non riuscita. */
    loadFailed: 'Caricamento dell’account di institor non riuscito. Riprova.',
    /** Titolo delle opzioni. */
    options: 'Opzioni dei progetti gestiti',
    /** Etichetta dell'account di fatturazione. */
    billing: 'Account di fatturazione',
    /** Aiuto. */
    billingHelp: 'Facoltativo, nella forma billingAccounts/…. Vuoto, si usa il primo account di fatturazione aperto.',
    /** Valore malformato. */
    billingInvalid: 'Scrivi billingAccounts/ seguito dall’identificativo, oppure lascia vuoto.',
    /** Etichetta della cartella. */
    folder: 'Cartella',
    /** Aiuto. */
    folderHelp:
      'Facoltativa: folders/<numero> per una cartella, organizations/<numero> per l’organizzazione. Vuota, i progetti nascono senza organizzazione.',
    /** Valore malformato. */
    folderInvalid: 'Scrivi folders/ o organizations/ seguito dal numero, oppure lascia vuoto.',
    /** Pulsante di salvataggio. */
    save: 'Salva opzioni',
    /** Esito. */
    saved: 'Opzioni salvate.',
    /** Esito fallito. */
    saveFailed: 'Salvataggio delle opzioni non riuscito. Riprova.',
  },

  /** Connessione gestita. */
  connection: {
    /** Etichetta nella tabella. */
    managedTag: 'Google di institor',
    /** Aiuto nella modifica. */
    managedHelp: 'La credenziale di un progetto gestito la cura institor: non si sostituisce.',
    /** Rotazione rifiutata. */
    managedRefused: 'Questa credenziale la gestisce institor e non si può sostituire.',
  },

  /** Schede della pagina di gestione. */
  tabs: {
    /** Progetti. */
    projects: 'Progetti',
    /** Consumi. */
    usage: 'Consumi',
  },

  /** Consumi di un progetto. */
  usage: {
    /** Etichetta del progetto. */
    project: 'Progetto Google Cloud',
    /** Testo di riempimento. */
    projectPlaceholder: 'Scegli un progetto',
    /** Nessun progetto scelto. */
    pick: 'Scegli un progetto per vederne richieste e fatturazione.',
    /** Nessun progetto. */
    noProjects: 'La credenziale non vede nessun progetto Google Cloud.',
    /** Etichetta del periodo. */
    window: 'Periodo',
    /** Ultimi N giorni. */
    days_one: 'Ultimo giorno',
    /** Ultimi N giorni. */
    days_other: 'Ultimi {{count}} giorni',
    /** Titolo delle richieste. */
    requestsTitle: 'Richieste per API',
    /** Colonne. */
    columns: {
      /** API. */
      service: 'API',
      /** Richieste. */
      requests: 'Richieste',
      /** Errori. */
      errors: 'Errori',
    },
    /** Nessuna richiesta. */
    empty: 'Nessuna richiesta nel periodo.',
    /** Monitoring spento. */
    requestsDisabled: 'L’API Cloud Monitoring è spenta nel progetto: attivala per vedere le richieste.',
    /** Titolo della fatturazione. */
    billingTitle: 'Fatturazione',
    /** Fatturazione attiva. */
    billingEnabled: 'Attiva',
    /** Fatturazione non attiva. */
    billingDisabled: 'Non attiva',
    /** Stato. */
    billingState: 'Stato',
    /** Account. */
    billingAccount: 'Account di fatturazione',
    /** Nessun account. */
    noAccount: 'Nessuno',
    /** Progetto gestito: account non mostrato. */
    managedAccount: 'Account di institor',
    /** Collegamento alla console. */
    openConsole: 'Apri i report nella console',
    /** Nota sui costi. */
    costsNote:
      'I costi dettagliati richiedono l’esportazione della fatturazione in BigQuery. Finché non c’è, li trovi nei report della console.',
    /** API di fatturazione spenta. */
    billingApiDisabled: 'L’API Cloud Billing è spenta nel progetto: attivala per vedere la fatturazione.',
    /** Lettura non riuscita. */
    loadFailed: 'Caricamento dei consumi non riuscito. Riprova.',
  },

  /** Blocco nella scheda Strumenti del progetto. */
  managed: {
    /** Titolo. */
    title: 'Account Google di institor',
    /** Che cosa fa. */
    intro:
      'Senza un account Google suo, il progetto usa quello di institor: un progetto Google Cloud dedicato, preparato al primo avvio di un set.',
    /** Il progetto ha già Google. */
    hasOwn: 'Il progetto usa un account Google suo: quello di institor non serve.',
    /** Nessun progetto gestito. */
    none: 'Nessun progetto Google preparato. Si prepara al primo avvio di un set, o subito con «Prepara ora».',
    /** Lettura non riuscita. */
    loadFailed: 'Caricamento del progetto Google gestito non riuscito. Riprova.',
    /** Stati. */
    state: {
      /** In preparazione. */
      provisioning: 'In preparazione',
      /** Pronto. */
      ready: 'Pronto',
      /** Errore. */
      failed: 'Errore',
      /** Migrato. */
      migrated: 'Migrato',
      /** In chiusura. */
      deleting: 'In chiusura',
    },
    /** Etichetta dello stato. */
    stateLabel: 'Stato',
    /** Etichetta del progetto Google Cloud. */
    gcpProject: 'Progetto Google Cloud',
    /** Etichetta del dettaglio. */
    detail: 'Dettaglio',
    /** Spiegazione della preparazione. */
    provisioningHelp: 'Google impiega qualche minuto. La pagina si aggiorna quando la ricarichi.',
    /** Spiegazione della migrazione avvenuta. */
    migratedHelp: 'Il progetto ora usa un account Google dell’utente.',
    /** Pulsante di preparazione. */
    prepare: 'Prepara ora',
    /** Esito. */
    prepared: 'Preparazione avviata.',
    /** Esito fallito. */
    prepareFailed: 'Avvio della preparazione non riuscito. Riprova.',
    /** Pulsante della migrazione e titolo del cassetto. */
    useMine: 'Usa il mio account Google',
    /** Errori. */
    errors: {
      /** Account di piattaforma mancante. */
      platformMissing:
        'L’account Google di institor non è collegato. Chiedi a chi amministra la piattaforma di collegarlo.',
      /** Il progetto ha già Google. */
      projectHasGoogle: 'Il progetto ha già un collegamento Google suo: quello di institor non serve.',
      /** Progetto gestito non pronto. */
      notReady: 'Il progetto gestito non è ancora pronto. Aspetta che la preparazione finisca e riprova.',
    },
  },

  /** Cassetto di migrazione. */
  migrate: {
    /** Che cosa succede. */
    intro: 'Il progetto passa a un tuo account Google. Il set si ferma e riparte con la credenziale nuova.',
    /** Etichetta della connessione. */
    connection: 'Il mio account Google',
    /** Testo di riempimento. */
    connectionPlaceholder: 'Scegli una connessione',
    /** Nessuna connessione. */
    noConnections: 'Nessuna connessione Google tua: collegala dalla pagina Strumenti.',
    /** Connessione mancante. */
    connectionMissing: 'Scegli una connessione.',
    /** Etichetta del modo. */
    mode: 'Modo',
    /** Adozione. */
    adopt: 'Adotta il progetto',
    /** Spiegazione dell'adozione. */
    adoptHelp:
      'Il progetto {{id}} passa al tuo account: ne diventi amministratore e la fatturazione passa a te. Le risorse restano dove sono.',
    /** Progetto nuovo. */
    newProject: 'Nuovo progetto nel mio account',
    /** Spiegazione del progetto nuovo. */
    newProjectHelp:
      'Si crea un progetto nel tuo account e il collegamento passa lì. Il progetto di institor si chiude dopo 30 giorni: le risorse le spostano gli agenti se lo chiedi.',
    /** Etichetta dell'ID nuovo. */
    newId: 'ID del progetto nuovo',
    /** Pulsante che usa l'ID proposto. */
    useSuggestion: 'Usa {{id}}',
    /** Pulsante di invio. */
    submit: 'Migra',
    /** Esito. */
    done: 'Progetto portato sul tuo account Google.',
    /** Esito fallito. */
    failed: 'Migrazione non riuscita. Riprova.',
    /** Connessione altrui. */
    forbidden: 'Puoi usare solo le tue connessioni Google.',
  },

  /** Esito della migrazione. */
  result: {
    /** Titolo. */
    title: 'Migrazione conclusa',
    /** Progetto ora usato. */
    project: 'Il collegamento ora usa il progetto {{id}}.',
    /** Proprietario concesso. */
    ownerGranted: 'Il tuo account è Proprietario del progetto.',
    /** Proprietario non concesso. */
    ownerNotGranted:
      'Google concede il ruolo di Proprietario solo con un invito. Intanto hai ruoli che bastano per lavorare e gestire la fatturazione.',
    /** Come diventare Proprietario. */
    ownerHowTo:
      'Per diventare Proprietario apri IAM nella console del progetto, aggiungi il tuo account con il ruolo Proprietario e accetta l’invito che ricevi per email.',
    /** Collegamento a IAM. */
    openIam: 'Apri IAM nella console',
    /** Fatturazione spostata. */
    billingMoved: 'La fatturazione è passata al tuo account di fatturazione.',
    /** Fatturazione non spostata. */
    billingNotMoved:
      'Non hai un account di fatturazione aperto: la fatturazione resta di institor. Aprine uno nella console e collegalo al progetto.',
    /** Chiudi. */
    close: 'Chiudi',
  },
};

/** Forma dei testi dell'account Google di institor. */
export type GoogleManaged = typeof googleManaged;
